module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "intro"
  }, [_c('a', {
    attrs: {
      "id": "page_01"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eighty years after the Battles of El Alamein it’s hard to imagine how close the Axis powers came to victory. For almost six months the two sides wrestled like lions, the Axis needing to secure Suez to open a supply line to the southern USSR whilst blocking the Allies’ south-eastern passages, while the Allies needed Suez to maintain a passage for troops and material, including vital oil supplies, as well as to continue the fight against Imperial Japan.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German prisoners wait for transport at El Alamein, 25 October 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Armourers prepare to load 250lb GP bombs onto the Kittyhawks of 260 Squadron, RAF. Note the truck at the head of the trolleys with its tripod Browning machine-gun mount. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Map showing the features that were to play so prominent a role in the coming battles.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Battles of El Alamein were bordered by the Qattara Depression, with its salt lakes, cliffs and fine sand to the south with the Mediterranean Sea coastline marking the northern boundary. This meant that neither side was able to outflank the other en masse, though reconnaissance troops from both sides regularly used the Qattara Depression to circumnavigate defensive positions built by both sides, strung across the area and running north to south.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not all challenges came from the enemy. A wall of sand approaches Allied lines late in October 1942. (IWM)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0001-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Memorial to the 9th Australian Division at the El Alamein Cemetery. (Unknown)")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Troops also had to face the daily threats of heat, thirst and scorpions, as well as the Sirocco carrying fine sand that reduced visibility and affected engines. For the Axis their problems were compounded by a logistics network constantly under attack, and having to use captured stores to continue their advance. For the Allies, fighting the Deutsches Afrikakorps would highlight shortcomings in organization that would be equally costly. For both sides the stakes were as high as they could be.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the end the Allies excelled themselves. Superb leadership, sound intelligence and planning, coupled with better equipment and service support as well as greater numbers turned the tide against the Axis forces decisively.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Today signs of battle remain; abandoned dugouts, empty fuel cans and unexploded ordnance abound. It’s almost impossible to imagine that an army on the cusp of defeat in early summer 1942 could achieve so complete a victory six months later.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ded4191","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter1.vue
// module id = 69
// module chunks = 0